// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://citruscountyclerk-vendor.aclarian.com',
  appName: 'Citrus County BOCC  | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pubd998163e425428ba6a6bde82decfc86b',
  datadogApplicationId: '5b551fe5-eed9-4f13-9538-66a8934f72a0',
  datadogService: 'invoicing_citrus_county',
  ApiKey: '8@wDxR2#Jh5tL%',
  env: 'PROD',
  version: packageInfo.version,
};
